'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('react');
var WebFont = require('webfontloader');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var WebFont__default = /*#__PURE__*/_interopDefaultLegacy(WebFont);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useFonts = function useFonts(fonts) {
  var _useState = react.useState(false),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var families = Object.keys(fonts).reduce(function (allFamilies, type) {
    var _fonts$type$families = fonts[type].families,
        typeFamilies = _fonts$type$families === void 0 ? [] : _fonts$type$families;
    return [].concat(_toConsumableArray__default["default"](allFamilies), _toConsumableArray__default["default"](typeFamilies));
  }, []).sort();
  react.useEffect(function () {
    var canceled = false;

    var onFontsActive = function onFontsActive() {
      if (!canceled) {
        setLoaded(true);
      }
    };

    WebFont__default["default"].load(_objectSpread(_objectSpread({}, fonts), {}, {
      active: onFontsActive
    }));
    return function () {
      canceled = true;
    };
  }, _toConsumableArray__default["default"](families));
  return {
    loaded: loaded
  };
};

exports.useFonts = useFonts;
